import { createFileRoute } from "@tanstack/react-router";
import { RouteGuard } from "@/components/RouteGuard";
import { CourseManagement } from "@/lib/lazyPages";

export const Route = createFileRoute("/admin/courses/")({
  component: () => (
    <RouteGuard access={{ kind: "admin" }}>
      <CourseManagement />
    </RouteGuard>
  ),
});
